/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-favoris-logement': {
    width: 23.904,
    height: 23.8,
    viewBox: '7.796 7.8 23.904 23.8',
    data: '<path pid="0" _fill="#FFF" d="M31 15.5L20.6 8.1c-.3-.2-.6-.3-.9-.3-.3 0-.6.1-.9.3L8.4 15.5l-.3.3c-.3.4-.4.9-.2 1.3.1.5.5.8 1 1 .1 0 .3.1.5.1h1.5v11.9c0 .801.7 1.5 1.5 1.5h14.8c.8 0 1.5-.699 1.5-1.5V18.3h1.5c.5 0 .899-.2 1.2-.6.1-.1.199-.3.199-.4 0-.2.101-.3.101-.5-.1-.5-.3-1-.7-1.3m-3.8 1.2v13.4h-15V16.7h-3l10.4-7.4L30 16.7h-2.8z"/>'
  }
})
